import { BasemapOptionEntity } from '@gishub/domain';
import { IBasemapSourceStrategy } from '../strategies/i-basemap-source-strategy';
import { IBasemapSourceStrategyConfig } from '../strategies/i-basemap-source-strategy-config';
import { BasemapStrategyFactory } from './basemap-strategy-factory';
import { WithAttributionDecorator } from '../decorators/with-attribution-decorator';
import { WithSubdomainsDecorator } from '../decorators/with-subdomains-decorator';

export class BasemapLayerFactory {
  static createConfig(option: BasemapOptionEntity): IBasemapSourceStrategyConfig {
    let strategy: IBasemapSourceStrategy = BasemapStrategyFactory.getStrategy(option.type, option.provider);
    strategy = new WithSubdomainsDecorator(strategy as any);
    strategy = new WithAttributionDecorator(strategy as any);
    return strategy.createConfig(option);
  }
}
